export default "__VITE_ASSET__DFm5I7Gc__"